<template>
  <div id="app">
    <p>
      Welcome to your Vue.js app with dropzone!
    </p>
    <dropzone ref="myUniqueID" param-name="something" id="myVueDropzone" url="https://httpbin.org/post" v-on:vdropzone-success="success"></dropzone>
    <button v-on:click="processFiles">Upload the things</button>

  </div>
</template>

<script>
  import Dropzone from '../src/index'
  export default {
    name: 'MainApp',
    components: {
      Dropzone
    },
    data () {
      return {
        langObj: {dictDefaultMessage: 'something'}
      }
    },
    methods: {
      'success': function (file) {
        console.log(file)
      },
      'processFiles': function () {
        this.$refs.myUniqueID.manuallyAddFile({ name: 'somethig', size: 12345, type: 'image/jpeg' }, "https://placehold.it/400x400")      
      }
    }
  }
</script>

<style scoped>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';
</style>


/** WEBPACK FOOTER **
 ** App.vue?7f99b23c
 **/